class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
    this.bindOverlay();
    this.setHeaderCartIconAccessibility();
  }

  bindOverlay() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay && overlay.dataset.cartOverlayBound !== 'true') {
      overlay.dataset.cartOverlayBound = 'true';
      overlay.addEventListener('click', () => this.close());
    }
  }

  setHeaderCartIconAccessibility() {
    document.querySelectorAll('#cart-icon-bubble, [data-cart-open]').forEach((cartLink) => {
      if (cartLink.dataset.cartDrawerBound === 'true') return;
      cartLink.dataset.cartDrawerBound = 'true';
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        if (cartLink.hasAttribute('data-cart-open') || cartLink.id === 'cart-icon-bubble') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE' || event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    requestAnimationFrame(() => this.classList.add('animate', 'active'));
    document.body.classList.add('overflow-hidden');

    const focusAfterTransition = () => {
      const container = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : this.querySelector('#CartDrawer');
      const focusElement = this.querySelector('.drawer__close') || this.querySelector('.drawer__inner');
      if (container && focusElement && typeof trapFocus === 'function') trapFocus(container, focusElement);
    };
    this.addEventListener('transitionend', focusAfterTransition, { once: true });
    setTimeout(focusAfterTransition, 450);
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    const content = cartDrawerNote.nextElementSibling;
    if (content?.id) cartDrawerNote.setAttribute('aria-controls', content.id);
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    cartDrawerNote.parentElement?.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    if (!parsedState) return;
    this.classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const html = parsedState.sections?.[section.id];
      if (!html) return;
      const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!target) return;
      const rendered = this.getSectionInnerHTML(html, section.selector);
      if (rendered !== null) target.innerHTML = rendered;
    });

    this.bindOverlay();
    this.setHeaderCartIconAccessibility();
    window.WhiteholeCart?.updateCartCount?.();
    setTimeout(() => this.open(this.activeElement), 20);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const selected = documentFragment.querySelector(selector) || documentFragment.querySelector('.shopify-section');
    return selected ? selected.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}

if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);
